import { plainToClass } from 'class-transformer';
import {
  API_REGION_CREATE,
  API_REGION_DELETE,
  API_REGION_FIND_ALL,
  API_REGION_FIND_ONE,
  API_REGION_UPDATE
} from '../api.routes';
import { BaseApi } from './base.api';
import { RegionDto } from '../dto';
import { FindAllResponse } from '../types';

export class RegionApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<RegionDto>> {
    return this.httpClient
      .get(API_REGION_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(RegionDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<RegionDto> {
    return this.httpClient
      .get(API_REGION_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(RegionDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<RegionDto> {
    return this.httpClient.post(API_REGION_CREATE, data).then(({ data }) => {
      return plainToClass(RegionDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<RegionDto> {
    return this.httpClient.put(API_REGION_UPDATE, data).then(({ data }) => {
      return plainToClass(RegionDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_REGION_DELETE, {
      pathParams: { uuid }
    });
  }
}
